import React, { useMemo } from 'react';
import { Icon } from '../../ui/icon/Icon';
import { defaultPersonaIcon } from '../../constants/consts';
import { getClassNames } from '../../helpers/classHelpers';
import { PersonaOption } from '../../models/types';
import { AdaptiveIconProps, IconTheme } from '../../ui/icon/Icon.types';
import style from './ChatWelcome.module.scss';

type Props = {
    avatar?: AdaptiveIconProps['iconName'];
    persona?: PersonaOption;
};

const ChatWelcome: React.FC<Props> = ({ avatar, persona }) => {
    const icon = persona?.icon || persona?.avatar || avatar;
    const iconName = useMemo(() => { return icon?.startsWith('http') ? `${icon}?width=100` : icon; }, [icon]);
    if (!persona) return null;
    return (
        <div className={style['chat-welcome']}>
            {iconName && <Icon.Adaptive size={54} title={''} theme={IconTheme.accent} iconName={iconName} className={style.avatar} />}
            {!iconName && <Icon.Svg borderSize={2} size={54} title={''} iconName={defaultPersonaIcon} className={style.avatar} fill='red' borderColor='red' />}
            <span className={style.title}>{persona.title}</span>
            <label className={getClassNames(['df-helper-text'])}>{persona?.description}</label>
        </div>
    );
};

export default ChatWelcome;